// extracted by mini-css-extract-plugin
module.exports = {"signUpPersonaRoot":"sign-up-persona-root_signUpPersonaRoot__1OPoI","personas":"sign-up-persona-root_personas__QoZYH"};